import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocNationalityEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 className="heading-1" id="nationality">Language</h3>
                    <div className="description">The extraction of an entity type Language represents a specific human language or dialect used for communication 
                        An example of a language can be seen below:
                    </div>
                    <div className="example-content">
                        <div className="line">Naskh script</div>
                        <div className="line">Hindi</div>
                        <div className="line">Spanish</div>
                    </div>
                    <br/>

                    <h5 className="heading-2">Example</h5>
                    <div className="example-content">
                    Sarkhej Roza houses incomplete yet beautifully handwritten copies of the Quran, a manuscript of Hidaya, and a printed Quran with Persian 
                    and Urdu translations. Additionally, an old handwritten copy of the Quran, completed in 1649 in the elegant Naskh script, 
                    remains one of the site's treasured possessions.
                    </div>
                    {/* ! NOTE UPDATE HTTP RUNNER */}
                    <HttpRunner example="language1" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_LANGUAGE) : null}/>
                </div>
            </div>
        );
    }
}

export default DocNationalityEntity;